module.exports = __webpack_public_path__ + "static/media/03.df41e4cf.png";